<form [formGroup]="aanslagIbFormGroup">
    <div>
        <div class="col-4 pt-1" style="min-width: 200px">
            <p>Aanslag jaar</p>
        </div>
        <div class="col-3">
            <snelstart-ui-text-form-control formControlName="aangifteJaar"
                                            id="aangifteJaar"
                                            class="custom-input-125"
            ></snelstart-ui-text-form-control>
        </div>
        <div class="col-3 me-1">
        </div>
    </div>
    <div>
        <div class="col-4 pt-1" style="min-width: 200px">
            <p>Aanslagnummer</p>
        </div>
        <div class="col-3">
            <snelstart-ui-text-form-control formControlName="aanslagnummer"
                                            id="aanslagnummer"
                                            class="custom-input-125"
            ></snelstart-ui-text-form-control>
        </div>
        <div class="col-3 me-1">

        </div>
    </div>
    <div>
        <div class="col-4 pt-1" style="min-width: 200px">
            <p>Aanslagdatum</p>
        </div>
        <div class="col-3">
            <snelstart-ui-text-form-control formControlName="aanslagdatum"
                                            id="aanslagdatum"
                                            class="custom-input-125"
            >
                <ng-template let-aanslagdatum>
                    {{ aanslagdatum | date: 'dd-MM-yyyy' }}
                </ng-template>
            </snelstart-ui-text-form-control>
        </div>
        <div class="col-3 me-1">

        </div>
    </div>
    <div>
        <div class="col-4 pt-1" style="min-width: 200px">
            <p>Uiterste betaaldatum</p>
        </div>
        <div class="col-3">
            <snelstart-ui-text-form-control formControlName="uitersteBetaalDatum"
                                            id="uitersteBetaalDatum"
                                            class="custom-input-125"
            >
                <ng-template let-uitersteBetaalDatum>
                    {{ uitersteBetaalDatum | date: 'dd-MM-yyyy' }}
                </ng-template>
            </snelstart-ui-text-form-control>
        </div>
        <div class="col-3 me-1">

        </div>
    </div>
</form>

<div>
    <br/>
    <br/>
</div>

<div>
    <ng-container>
        <div class="row">
            <div class="col-4 pt-4" style="min-width: 200px">
                <p>Inkomen box 1</p>
            </div>
            <div class="col-3">
                <form [formGroup]="aanslagIbFormGroup">
                    <snelstart-ui-number-form-control formControlName="inkomenBox1"
                                                      id="inkomenbox1-aanslag"
                                                      label="Aanslag"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-3">
                <form [formGroup]="berekeningFormGroup">
                    <ng-container formGroupName="box1">
                        <snelstart-ui-number-form-control formControlName="belastbaarInkomen"
                                                          id="inkomenbox1-aangifte"
                                                          label="Aangifte"
                                                          class="custom-input-125"
                                                          [decimals]="0"
                                                          align="right"
                                                          prefix="€"
                        ></snelstart-ui-number-form-control>
                    </ng-container>
                </form>
            </div>
        </div>
    </ng-container>
</div>

<!--<div>-->
<!--  <ng-container>-->
<!--    <div class="row">-->
<!--      <div class="col-4 pt-1" style="min-width: 200px">-->
<!--        <p>Inkomen box 2</p>-->
<!--      </div>-->
<!--      <div class="col-3">-->
<!--        <form [formGroup]="berekeningFormGroup">-->
<!--          <ng-container formGroupName="box2">-->
<!--            <snelstart-ui-number-form-control formControlName="belastbaarInkomen"-->
<!--                                              id="inkomenbox2-aangifte"-->
<!--                                              class="custom-input-125"-->
<!--                                              [decimals]="0"
                                          align="right"
                                          prefix="€"
                                          align="right"
                                          prefix="€"-->
<!--                                              align="right"-->
<!--            ></snelstart-ui-number-form-control>-->
<!--          </ng-container>-->
<!--        </form>-->
<!--      </div>-->
<!--      <div class="col-3">-->
<!--        <form [formGroup]="aanslagIbFormGroup">-->
<!--          <snelstart-ui-number-form-control formControlName="inkomenBox2"-->
<!--                                            id="inkomenbox2-aanslag"-->
<!--                                            class="custom-input-125"-->
<!--                                            [decimals]="0"
                                          align="right"
                                          prefix="€"
                                          align="right"
                                          prefix="€"-->
<!--                                            align="right"-->
<!--          >-->
<!--          </snelstart-ui-number-form-control>-->
<!--        </form>-->
<!--      </div>-->
<!--    </div>-->
<!--  </ng-container>-->
<!--</div>-->

<div>
    <ng-container>
        <div class="row">
            <div class="col-4 pt-1" style="min-width: 200px">
                <p>Inkomen box 3</p>
            </div>
            <div class="col-3">
                <form [formGroup]="aanslagIbFormGroup">
                    <snelstart-ui-number-form-control formControlName="inkomenBox3"
                                                      id="inkomenbox3-aanslag"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-3">
                <form [formGroup]="berekeningFormGroup">
                    <ng-container formGroupName="box3">
                        <snelstart-ui-number-form-control formControlName="belastbaarInkomen"
                                                          id="inkomenbox3-aangifte"
                                                          class="custom-input-125"
                                                          [decimals]="0"
                                                          align="right"
                                                          prefix="€"
                        ></snelstart-ui-number-form-control>
                    </ng-container>
                </form>
            </div>
        </div>
    </ng-container>
</div>

<div>
    <ng-container>
        <div class="row">
            <div class="col-4 pt-1" style="min-width: 200px">
                <p>Inkomstenbelasting</p>
            </div>
            <div class="col-3">
                <form [formGroup]="aanslagIbFormGroup">
                    <snelstart-ui-number-form-control formControlName="belastingBox1"
                                                      id="gecombineerdeInkomensheffing-aanslag"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-3">
                <form [formGroup]="berekeningFormGroup">
                    <snelstart-ui-number-form-control formControlName="gecombineerdeInkomensheffing"
                                                      id="gecombineerdeInkomensheffing-aangifte"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    ></snelstart-ui-number-form-control>
                </form>
            </div>
        </div>
    </ng-container>
</div>

<div>
    <ng-container>
        <div class="row">
            <div class="col-4 pt-1" style="min-width: 200px">
                <p>Premies volksverzekeringen</p>
            </div>
            <div class="col-3">
                <form [formGroup]="aanslagIbFormGroup">
                    <snelstart-ui-number-form-control formControlName="premiesVolksverzekeringen"
                                                      id="premieVolksverzekeringen-aanslag"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-3">
                <form [formGroup]="berekeningFormGroup">
                    <snelstart-ui-number-form-control formControlName="premieVolksverzekeringen"
                                                      id="premieVolksverzekeringen-aangifte"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    ></snelstart-ui-number-form-control>
                </form>
            </div>
        </div>
    </ng-container>
</div>

<div>
    <ng-container>
        <div class="row">
            <div class="col-4 pt-1" style="min-width: 200px">
                <p>Heffingskortingen</p>
            </div>
            <div class="col-3">
                <form [formGroup]="aanslagIbFormGroup">
                    <snelstart-ui-number-form-control formControlName="heffingsKortingen"
                                                      id="heffingsKortingen-aanslag"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-3">
                <form [formGroup]="berekeningFormGroup">
                    <ng-container formGroupName="heffingskortingen">
                        <snelstart-ui-number-form-control formControlName="totaal"
                                                          id="heffingsKortingen-aangifte"
                                                          class="custom-input-125"
                                                          [decimals]="0"
                                                          align="right"
                                                          prefix="€"
                        ></snelstart-ui-number-form-control>
                    </ng-container>
                </form>
            </div>
        </div>
    </ng-container>
</div>

<div>
    <ng-container>
        <div class="row">
            <div class="col-4 pt-1" style="min-width: 200px">
                <p>Dividendbelasting</p>
            </div>
            <div class="col-3">
                <form [formGroup]="aanslagIbFormGroup">
                    <snelstart-ui-number-form-control formControlName="verrekendeDividendbelasting"
                                                      id="alBetaaldeDividendbelasting-aanslag"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-3">
                <form [formGroup]="berekeningFormGroup">
                    <snelstart-ui-number-form-control formControlName="alBetaaldeDividendbelasting"
                                                      id="alBetaaldeDividendbelasting-aangifte"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    ></snelstart-ui-number-form-control>
                </form>
            </div>
        </div>
    </ng-container>
</div>

<div>
    <ng-container>
        <div class="row">
            <div class="col-4 pt-1" style="min-width: 200px">
                <p>Loonbelasting</p>
            </div>
            <div class="col-3">
                <form [formGroup]="aanslagIbFormGroup">
                    <snelstart-ui-number-form-control formControlName="verrekendeloonbelasting"
                                                      id="alBetaaldeLoonbelasting-aanslag"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-3">
                <form [formGroup]="berekeningFormGroup">
                    <snelstart-ui-number-form-control formControlName="alBetaaldeLoonbelasting"
                                                      id="alBetaaldeLoonbelasting-aangifte"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    ></snelstart-ui-number-form-control>
                </form>
            </div>
        </div>
    </ng-container>
</div>

<!--<div>-->
<!--  <ng-container>-->
<!--    <div class="row">-->
<!--      <div class="col-4 pt-1" style="min-width: 200px">-->
<!--        <p>Voorlopige aanslag</p>-->
<!--      </div>-->
<!--      <div class="col-3">-->
<!--        <form [formGroup]="berekeningFormGroup">-->
<!--          <snelstart-ui-number-form-control formControlName="voorlopigeAanslag"-->
<!--                                            id="voorlopige-aangifte"-->
<!--                                            class="custom-input-125"-->
<!--                                            [decimals]="0"
                                          align="right"
                                          prefix="€"-->
<!--                                            align="right"-->
<!--          ></snelstart-ui-number-form-control>-->
<!--        </form>-->
<!--      </div>-->
<!--      <div class="col-3">-->
<!--        <form [formGroup]="aanslagIbFormGroup">-->
<!--          <snelstart-ui-number-form-control formControlName="verrekendeVoorlopigeAanslagen"-->
<!--                                            id="voorlopige-aanslag"-->
<!--                                            class="custom-input-125"-->
<!--                                            [decimals]="0"
                                          align="right"
                                          prefix="€"-->
<!--                                            align="right"-->
<!--          >-->
<!--          </snelstart-ui-number-form-control>-->
<!--        </form>-->
<!--      </div>-->
<!--    </div>-->
<!--  </ng-container>-->
<!--</div>-->

<!--<div>-->
<!--  <ng-container>-->
<!--    <div class="row">-->
<!--      <div class="col-4 pt-1" style="min-width: 200px">-->
<!--        <p>Vergrijpboete</p>-->
<!--      </div>-->
<!--      <div class="col-3">-->
<!--        <form [formGroup]="berekeningFormGroup">-->
<!--          <snelstart-ui-number-form-control formControlName="verrekendeBelastingKortingBox2"-->
<!--                                            id="vergrijpboete-aangifte"-->
<!--                                            class="custom-input-125"-->
<!--                                            [decimals]="0"
                                          align="right"
                                          prefix="€"-->
<!--                                            align="right"-->
<!--          ></snelstart-ui-number-form-control>-->
<!--        </form>-->
<!--      </div>-->
<!--      <div class="col-3">-->
<!--        <form [formGroup]="aanslagIbFormGroup">-->
<!--          <snelstart-ui-number-form-control formControlName="vergrijpBoete"-->
<!--                                            id="vergrijpboete-aanslag"-->
<!--                                            class="custom-input-125"-->
<!--                                            [decimals]="0"
                                          align="right"
                                          prefix="€"-->
<!--                                            align="right"-->
<!--          >-->
<!--          </snelstart-ui-number-form-control>-->
<!--        </form>-->
<!--      </div>-->
<!--    </div>-->
<!--  </ng-container>-->
<!--</div>-->

<div>
    <ng-container>
        <div class="row">
            <div class="col-4 pt-1" style="min-width: 200px">
                <p>Belastingrente</p>
            </div>
            <div class="col-3">
                <form [formGroup]="aanslagIbFormGroup">
                    <snelstart-ui-number-form-control formControlName="rente"
                                                      id="belastingrente-aanslag"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-3">
                <form [formGroup]="berekeningFormGroup">
                    <snelstart-ui-number-form-control formControlName="verrekendeBelastingKortingBox2"
                                                      id="belastingrente-aangifte"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    ></snelstart-ui-number-form-control>
                </form>
            </div>
        </div>
    </ng-container>
</div>

<div>
    <ng-container>
        <div class="row">
            <div class="col-4 pt-1" style="min-width: 200px">
                <p>Bedrag van de aanslag</p>
            </div>
            <div class="col-3">
                <form [formGroup]="aanslagIbFormGroup">
                    <snelstart-ui-number-form-control formControlName="bedragVanDeAanslag"
                                                      id="bedrag-aanslag"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-3">
                <form [formGroup]="berekeningFormGroup">
                    <snelstart-ui-number-form-control formControlName="verschuldigdeInkomstenbelasting"
                                                      id="bedrag-aangifte"
                                                      class="custom-input-125"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                    ></snelstart-ui-number-form-control>
                </form>
            </div>
        </div>
    </ng-container>
</div>


